import Cookies from 'js-cookie';
import { ExperimentData } from '~helpers/types';

export const CONTENTEXP_755 = {
  identifier: 'contentexp-14-auth0-sign-ups',
  control: 'contentexp-14-auth0-sign-ups-control',
  treatment: 'contentexp-14-auth0-sign-ups-treatment',
};

export const ENDPAGE_35 = {
  identifier: 'endpage-35-optional-pathing',
  control: 'endpage-35-rebrandEpForm',
  treatment1: 'endpage-35-optionalPath1',
  treatment2: 'endpage-35-optionalPath2',
  treatment3: 'endpage-35-optionalPath3',
};

export const ENDPAGE_147 = {
  identifier: 'endpage-147-optional-pathing',
  control: 'endpage-147-rebrandEpForm',
  treatment1: 'endpage-147-optionalPathsMWeb1',
  treatment2: 'endpage-147-optionalPathsMWeb2',
  treatment3: 'endpage-147-optionalPathsMApp1',
  treatment4: 'endpage-147-optionalPathsMApp2',
};

export const ENDPAGE_171 = {
  identifier: 'endpage-171-dare-to-ask-v3',
  control: 'endpage-171-rebrandEpForm',
  treatment1: 'endpage-171-dareToAskV3SignUp',
  treatment2: 'endpage-171-dareToAskCreate',
  treatment3: 'endpage-171-dareToAskPractical',
};

export const ENDPAGE_162 = {
  identifier: 'endpage-162-product-userResearch',
  control: 'endpage-162-rebrandEpForm',
  treatment1: 'endpage-162-userResearchStandard',
  treatment2: 'endpage-162-userResearchStyled',
  treatment3: 'endpage-162-userResearchMobileStyle',
};

export const GROW_4165 = {
  identifier: 'grow-4165-endpageBuildWithAI',
  control: 'grow-4165-rebrandEpForm',
  treatment1: 'grow-4165-endpageBuildWithAIT1',
  treatment2: 'grow-4165-endpageBuildWithAIT2',
};

export const ENDPAGE_180 = {
  identifier: 'endpage-180-bwaiGIFTest',
  control: 'endpage-180-rebrandEpForm',
  treatment1: 'endpage-180-bwaiGIFInsight',
  treatment2: 'endpage-180-bwaiGIFCreation',
};

export const ENDPAGE_193 = {
  identifier: 'endpage-193-optional-pathing-v2',
  control: 'endpage-193-rebrandEpForm',
  treatment1: 'endpage-193-optionalPathOriginal',
  treatment2: 'endpage-193-optionalPathUpdated',
};

export const ENDPAGE_195 = {
  identifier: 'endpage-195-ep-personalized',
  control: 'endpage-195-rebrandEpForm',
  treatment1: 'endpage-195-popularTemplates',
  treatment2: 'endpage-195-employeeFeedbackTemplates',
};

export const ENDPAGE_243 = {
  identifier: 'endpage-243-ep-new-brand-campaign',
  control: 'endpage-243-rebrandEpForm',
  treatment1: 'endpage-243-rebrandEP2025',
};

export const ENDPAGE_232 = {
  identifier: 'endpage-232-brazilEndpage',
  control: 'endpage-232-rebrandEpFormIntl',
  treatment1: 'endpage-232-epFormBrazil',
};

export const ENDPAGE_249 = {
  identifier: 'endpage-249-existing-user-endpage-modernization-v1',
  control: 'endpage-249-rebrandExistingUser',
  treatment1: 'endpage-249-updatedExistingUser',
};

export const ENDPAGE_260 = {
  identifier: 'endpage-260-curiosityConPage',
  control: 'endpage-260-rebrandEpForm',
  treatment1: 'endpage-260-curiosityConEp',
};

/**
 * Previously, we handled cookies per experiment, but with the new batch experiments
 * endpoint, we now receive a single list of cookies for all experiments.
 * This function will need to be updated to process that unified list, simplifying the logic.
 */
export function setExperimentCookies(experiments: ExperimentData[] = []): void {
  if (!experiments.length) {
    return;
  }

  const cookie = experiments.find(exp => exp.cookies?.length)?.cookies?.[0] ?? null;
  if (!cookie) {
    return;
  }

  Cookies.set(cookie.name, cookie.value, { expires: cookie.age });
}
